import { render } from "./Ayudas.vue?vue&type=template&id=524a2748"
import script from "./Ayudas.vue?vue&type=script&lang=js"
export * from "./Ayudas.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__